module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1022-201c19b8f504de1ee8416d47bca28072.png";